<template>
  <fn-section
    constrained="m"
    padding-top="m"
    padding-bottom="m"
    background-color="sand-light"
  >
    <fn-error-intro
      v-if="unsubscribe"
      :image="image"
      :title="$t(`newsletter.unsubscribe.error.${type}.title`)"
      :description="$t(`newsletter.unsubscribe.error.${type}.description`)"
    />
    <fn-error-intro
      v-else
      :image="image"
      :title="$t('newsletter.registerConfirmation.error.title')"
      :description="$t('newsletter.registerConfirmation.error.description')"
    />
  </fn-section>
</template>

<script>
import { CONFIRMATION, NOT_FOUND, UNAVAILABLE } from '@/utils/subscription-types';

export default defineComponent({
  props: {
    image: {
      type: String,
      required: true,
    },
    unsubscribe: {
      type: Boolean,
    },
    type: {
      type: String,
      default: CONFIRMATION,
      validator: (value) => [CONFIRMATION, NOT_FOUND, UNAVAILABLE].includes(value),
    },
  },
});
</script>
